__turbopack_context__.v({
  "specialRate": "PdpMortgageEstimate-module__LsLp1G__specialRate",
});
